import * as React from "react";
import { FormField } from "./FormField.jsx";
// import * as cls from "./NumberBox.module.scss";
export { NumberBox };
/**
 * Числовое поле ввода.
 *
 * Представляет элемент управления, который можно использовать для отображения
 * и редактирования чисел.
 * 
 * @summary Числовое поле ввода.
 * @param {Object} props - Атрибуты элемента.
 * @param {React.RefObject} [props.inputRef] - Ссылка на элемент `input`.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.label] - Название и описание поля.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.required] - Обязательное для заполнения.
 * @param {boolean} [props.disabled] - Неактивно.
 * @param {boolean} [props.uncontrolled] - Неуправляемый компонент.
 * @param {boolean} [props.autoComplete] - Разрешено ли автозаполнение.
 * @param {string} [props.placeholder] - Отображать вместо пустого значения.
 * @param {number} [props.min] - Минимальное значение.
 * @param {number} [props.max] - Максимальное значение.
 * @param {number} [props.step] - Шаг изменения значения.
 * @param {string} [props.value] - Значение.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link ../frame/EventListener.js}
 * @see [Windows.UI.Xaml.Controls.NumberBox](https://learn.microsoft.com/ru-ru/windows/winui/api/microsoft.ui.xaml.controls.numberbox)
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function NumberBox(
  {
    inputRef,
    id,
    label,
    className,
    required,
    disabled,
    uncontrolled,
    autoComplete,
    placeholder,
    min,
    max,
    step,
    value,
    onChange
  }) {
  return (
    <FormField
      label={label}
      labelFor={id}
      required={required}
      className={className}>
      <input
        type="number"
        ref={inputRef}
        id={id}
        name={id}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
        value={uncontrolled ? undefined : (value ?? "")}
        onChange={onChange} />
    </FormField>
  );
}
